module.exports = __webpack_public_path__ + "assets/img/20210924-5.f5d5df62.png";